import {valueOf} from 'ui/keyboard';

export function createPayload({userInput}: AppState): AppendMoneyEventPayload {
  return {absolute: valueOf(userInput.keyboard)};
}
